import { useTranslation } from 'next-i18next'

import ResponsiveImage from '~/components/Image/ResponsiveImage'

export default function AtomicMathLayers(): React.ReactElement {
  const { t } = useTranslation('landing')

  return (
    <div className="relative my-24 w-screen">
      <div className="relative flex items-end w-screen h-50 bg-purple-gmedium-dark">
        <div className="bg-purple w-screen h-44" />
        <div className="absolute bg-violet-600 w-screen h-38" />
      </div>
      <ResponsiveImage
        className="absolute min-h-80 -top-14 w-full flex justify-center"
        height={320}
        imageClassName="min-h-80 min-w-[1266px]"
        srcKey="landing/layer-2.png"
        width={1200}
      />
      <div className="flex justify-center">
        <div className="absolute -top-22 mr-[500px] min-w-91 pt-16">
          <ResponsiveImage
            className="absolute min-h-96 flex justify-center top-0 object-contain"
            height={350}
            imageClassName="min-h-96"
            srcKey="landing/layer-3-left.png"
            width={350}
          />
          <div className="relative flex flex-col items-center z-20 max-w-56 mx-6 text-left -mt-2">
            <h3 className="text-5 font-bold mb-2 mr-auto">{t('atomicMath.atomicLearning')}</h3>
            <p>{t('atomicMath.meaningfulBuildingBlocks')}</p>
          </div>
        </div>
        <ResponsiveImage
          className="absolute min-h-50 -top-15 ml-12 flex justify-center"
          height={350}
          imageClassName="min-h-50"
          srcKey="landing/layer-3-center.png"
          width={350}
        />
        <div className="absolute -top-22 ml-[650px] min-w-91 pt-16">
          <ResponsiveImage
            className="absolute min-h-96 flex justify-center top-0 object-contain"
            height={350}
            imageClassName="min-h-96"
            srcKey="landing/layer-3-right.png"
            width={350}
          />
          <div className="relative flex flex-col items-center z-20 max-w-68 mx-6 text-left -mt-2">
            <h3 className="text-5 font-bold mb-2 ml-auto max-w-56 pr-4">{t('atomicMath.BeforeLearning')}</h3>
            <ul className="list-disc list-inside -mr-10">
              <li>{t('atomicMath.addSub')}</li>
              <li>{t('atomicMath.multiplication')}</li>
              <li>{t('atomicMath.fractions')}</li>
              <li>{t('atomicMath.fractionOp')}</li>
              <li>{t('atomicMath.signRules')}</li>
              <li>{t('atomicMath.basicAlgebra')}</li>
              <li>{t('atomicMath.parentheses')}</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  )
}
